import { render, staticRenderFns } from "./TermoValor.vue?vue&type=template&id=6cac5bac&scoped=true&"
import script from "./TermoValor.vue?vue&type=script&lang=js&"
export * from "./TermoValor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cac5bac",
  null
  
)

export default component.exports